module.exports = __webpack_public_path__ + "media/images/sale_crm/accounts-03a5a03031926a7759568a15cffea7dc.svg";